import {
  createEntityAdapter,
  createSlice,
  EntityState
} from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LoadingType } from '../../models/LoadingType';

import { VestingInfo } from '../../models/VestingInfo';
import { getVestingInfo } from './actions/getVestingInfo';

export const vestingAdapter = createEntityAdapter<VestingInfo>({
  selectId: (vesting) => vesting.contractAddress
});

export const initialStateVestingInfo = vestingAdapter.getInitialState({
  bknAmount: undefined,
  bnbAmount: undefined,
  loading: LoadingType.Idle,
  error: undefined
});
export type vestingInitialStateType = EntityState<VestingInfo> & {
  bknAmount?: string;
  bnbAmount?: string;
  loading: LoadingType;
  error: string;
};
export const vestingSlice = createSlice({
  name: 'vestingInfo',
  initialState: initialStateVestingInfo,
  reducers: {
    cleanVestingInfo: (state) => {
      vestingAdapter.removeAll(state);
      state.bknAmount = undefined;
      state.bnbAmount = undefined;
      state.loading = LoadingType.Idle;
      state.error = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getVestingInfo.fulfilled, (state, { payload }) => {
      const { vestingInfoList, bknAmount, bnbAmount } = payload;
      state.loading = LoadingType.Succeeded;
      state.bknAmount = bknAmount;
      state.bnbAmount = bnbAmount;
      if (vestingInfoList.length > 0) {
        vestingAdapter.setAll(state, vestingInfoList);
      }
    });
    builder.addCase(getVestingInfo.pending, (state) => {
      state.loading = LoadingType.Pending;
    });
    builder.addCase(getVestingInfo.rejected, (state, { payload }) => {
      state.error = payload.errorMessage;
      state.loading = LoadingType.Failed;
    });
  }
});

export const vestingInfoSelectors = vestingAdapter.getSelectors(
  (state: RootState) => {
    return state.vestingInfo;
  }
);
export const { selectAll: selectAllVestingInfo, selectById } =
  vestingInfoSelectors;
export const selectVestingInfoLoading = (state: RootState): LoadingType =>
  state.vestingInfo.loading;
export const selectVestingInfoByContractAddress = (
  state: RootState,
  contractAddress: string
): VestingInfo | undefined => {
  return selectById(state, contractAddress);
};
export const selectBalance = (
  state: RootState
): { bknAmount?: string; bnbAmount?: string } => {
  return {
    bknAmount: state.vestingInfo.bknAmount,
    bnbAmount: state.vestingInfo.bnbAmount
  };
};

export const vestingInfoReducer = vestingSlice.reducer;
